import {LogLevel} from '@/shared/lib/logger';

import {getEnvVar} from './util';

export {FIREBASE_CONFIG} from './firebaseConfig';

export const DEBUG = Boolean(getEnvVar('DEV'));

export const LOG_LEVEL = getEnvVar<LogLevel>('VITE_LOG_LEVEL');

export const BUILD_ID = getEnvVar('VITE_BUILD_ID');

export const BUILD_INFO = getEnvVar('VITE_BUILD_INFO');

export const API_URL = getEnvVar('VITE_API_URL');

export const FLY_URL = getEnvVar('VITE_FLY_URL');

export const SITE_URL = getEnvVar('VITE_SITE_URL');

export const APPLE_OAUTH_REDIRECT_URL = getEnvVar(
  'VITE_APPLE_OAUTH_REDIRECT_URL'
);

export const FIREBASE_VAPID_KEY = getEnvVar('VITE_FIREBASE_VAPID_KEY');

export const FACEBOOK_PIXEL_ID = getEnvVar('VITE_FACEBOOK_PIXEL_ID');

export const TIKTOK_PIXEL_ID = getEnvVar('VITE_TIKTOK_PIXEL_ID');

export const AXON_EVENT_KEY = getEnvVar('VITE_AXON_EVENT_KEY');

export const ROLLBAR_TOKEN = getEnvVar('VITE_ROLLBAR_TOKEN');

export const GOOGLE_CLIENT_ID = getEnvVar('VITE_GOOGLE_CLIENT_ID');

export const GOOGLE_MERCHANT_ID = getEnvVar('VITE_GOOGLE_MERCHANT_ID');

type MockBoostGeoposition = undefined | {latitude: number; longitude: number};
let mockGeopositionEnv: MockBoostGeoposition;
if (getEnvVar('VITE_MOCK_BOOST_GEOPOSITION') !== 'false') {
  const [latitude, longitude] = getEnvVar('VITE_MOCK_BOOST_GEOPOSITION').split(
    ','
  );
  mockGeopositionEnv = {
    latitude: Number(latitude),
    longitude: Number(longitude),
  };
}
export const MOCK_BOOST_GEOPOSITION: MockBoostGeoposition = mockGeopositionEnv;
